import React, {ReactElement} from 'react'
import FacilitiesRepository from '../components/facilities/FacilitiesRepository'
import ResidentReserveFacilityInputPage from '../components/reservations/ResidentReserveFacilityInputPage'
import HolidaysRepository from '../components/HolidaysRepository'
import {ReserveFacilityModel} from '../components/reservations/ReserveFacilityModel'
import EventEmitterExResident from '../components/shared/pageBaseComponents/EventEmitterExResident'
import ReservationsRepository from '../components/reservations/ReservationsRepository'
import NatRidgeRepo from '../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import NatRoomNumberRepo from '../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import ResidentReserveFacilityTopPage from '../components/reservations/ResidentReserveFacilityTopPage'
import CondominiumsRepository from '../components/condominiums/CondominiumsRepository'
import ResidentMyReservationsPage from '../components/reservations/ResidentMyReservationsPage'
import ResidentReserveFacilityUpdatePage from '../components/reservations/ResidentReserveFacilityUpdatePage'
import ResidentReserveFacilityInputConfirmPage from '../components/reservations/ResidentReserveFacilityInputConfirmPage'
import ResidentReserveFacilityUpdateConfirmPage
    from '../components/reservations/ResidentReserveFacilityUpdateConfirmPage'
import NatCurrentDateTimeRepo from '../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import ResidentReserveFacilityDetailPage from '../components/reservations/ResidentReserveFacilityDetailPage'
import ResidentReserveFacilityInputCompletePage
    from '../components/reservations/ResidentReserveFacilityInputCompletePage'
import ResidentReserveFacilityUpdateCompletePage
    from '../components/reservations/ResidentReserveFacilityUpdateCompletePage'
import ResidentReserveFacilityCancelCompletePage
    from '../components/reservations/ResidentReserveFacilityCancelCompletePage'
import ResidentReserveFacilityCancelConfirmPage
    from '../components/reservations/ResidentReserveFacilityCancelConfirmPage'
import ResidentReserveExtraReservationPage from '../components/reservations/ResidentReserveExtraReservationPage'
import ResidentFacilityReservationStatusPage from '../components/reservations/ResidentFacilityReservationStatusPage'
import ResidentAccountTransferApplyToResonaPage
    from '../components/accountTransfer/ResidentAccountTransferApplyToResonaPage'
import {RECEIVING_AGENCY_CD} from '../CodeMaster'
import NatTokenRepo from '../__NoAutomatedTests/components/token/repository/NatTokenRepo'
import AccountTransferApplyResultPage from '../components/accountTransfer/AccountTransferApplyResultPage'
import NatResidentUserRepo from '../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo'
import ResidentAccountTransferApplyToSmbcPage
    from '../components/accountTransfer/ResidentAccountTransferApplyToSmbcPage'
import ResidentAccountTransferPrivacyPolicyToSmbcPage
    from '../components/accountTransfer/ResidentAccountTransferPrivacyPolicyToSmbcPage'
import {MeetingRepositoryForResident} from '../components/assocDirector/MeetingRepositoryForResident'
import ResidentMeetingDetailPage from '../components/assocDirector/ResidentMeetingDetailPage'
import ResidentAssocTopPage from '../components/assocDirector/ResidentAssocTopPage'
import ResidentCommentReplyPage from '../components/assocDirector/ResidentCommentReplyPage'
import ResidentMeetingListPage from '../components/assocDirector/ResidentMeetingListPage'
import {Route} from 'react-router-dom'
import RouterPropsInjector, {RouterProps} from '../components/shared/RouterPropsInjector'
import ResidentAccessControlManagerForRikbRedirectPage
    from '../components/reservations/ResidentAccessControlManagerForRikbRedirectPage'
import ResidentUnitOwnerConfirmationPage from '../components/generalMeeting/ResidentUnitOwnerConfirmationPage'
import ResidentUnitOwnerConfirmationCompletePage
    from '../components/generalMeeting/ResidentUnitOwnerConfirmationCompletePage'
import ResidentGeneralMeetingRepo from '../components/generalMeeting/ResidentGeneralMeetingRepo'
import ResidentUnitOwnerConfirmationRedirectPage
    from '../components/generalMeeting/ResidentUnitOwnerConfirmationRedirectPage'
import ResidentUnitOwnerConfirmationKeyInputPage
    from '../components/generalMeeting/ResidentUnitOwnerConfirmationKeyInputPage'
import ResidentUnitOwnerConfirmationVerificationMethodSelectionPage
    from '../components/generalMeeting/ResidentUnitOwnerConfirmationVerificationMethodSelectionPage'
import ResidentGeneralMeetingListPage from '../components/generalMeeting/ResidentGeneralMeetingListPage'
import ResidentPastGeneralMeetingListPage from '../components/generalMeeting/ResidentPastGeneralMeetingListPage'
import ResidentGeneralMeetingDetailPage from '../components/generalMeeting/ResidentGeneralMeetingDetailPage'
import ResidentVotingPreferenceMethodSelectionPage
    from '../components/generalMeeting/ResidentVotingPreferenceMethodSelectionPage'
import ResidentVotingPreferenceAttendanceConfirmationPage
    from '../components/generalMeeting/ResidentVotingPreferenceAttendanceConfirmationPage'
import ResidentVotingPreferenceCompletePage from '../components/generalMeeting/ResidentVotingPreferenceCompletePage'
import ResidentVotingPreferenceProxyInputPage from '../components/generalMeeting/ResidentVotingPreferenceProxyInputPage'
import ResidentVotingPreferenceProxyConfirmationPage
    from '../components/generalMeeting/ResidentVotingPreferenceProxyConfirmationPage'
import NatUseFunctionMasterRepo
    from '../__NoAutomatedTests/components/useFunctionMaster/repository/NatUseFunctionMasterRepo'
import ResidentVotingPreferenceProposalResponseInputPage
    from '../components/generalMeeting/ResidentVotingPreferenceProposalResponseInputPage'
import ResidentVotingPreferenceProposalResponseConfirmationPage
    from '../components/generalMeeting/ResidentVotingPreferenceProposalResponseConfirmationPage'

interface Props {
    eventEmitter: EventEmitterExResident
    condominiumsRepo: CondominiumsRepository
    facilitiesRepo: FacilitiesRepository
    reservationsRepo: ReservationsRepository
    holidaysRepo: HolidaysRepository
    reservationModel: ReserveFacilityModel
    ridgeRepo: NatRidgeRepo
    roomNumberRepo: NatRoomNumberRepo
    tokenRepo: NatTokenRepo
    residentUserRepo: NatResidentUserRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    meetingRepoForResident: MeetingRepositoryForResident
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
    useFunctionMasterRepo: NatUseFunctionMasterRepo
}

const AccountTransferApplyResult: React.FC<Props & RouterProps> = (
    props: Props & RouterProps,
): ReactElement => {
    const status = props.params.status
    let pageTitle: string
    switch (status) {
        case 'complete':
            pageTitle = '口座振替登録完了 | 素敵ネット'
            break
        case 'cancel':
            pageTitle = '口座振替登録中断 | 素敵ネット'
            break
        case 'error':
            pageTitle = '口座振替登録エラー | 素敵ネット'
            break
        default:
            return <></>
    }
    // @ts-ignore
    return <AccountTransferApplyResultPage
        navigate={props.navigate}
        eventEmitter={props.eventEmitter}
        pageTitle={pageTitle}
        status={status}
    />
}

export function RoutesResident(routesProps: Props): ReactElement {
    const {
        eventEmitter,
        condominiumsRepo,
        facilitiesRepo,
        reservationsRepo,
        holidaysRepo,
        reservationModel,
        ridgeRepo,
        roomNumberRepo,
        tokenRepo,
        residentUserRepo,
        currentDateTimeRepo,
        meetingRepoForResident,
        residentGeneralMeetingRepo,
        useFunctionMasterRepo,
    }: Props = routesProps

    return (<>
        <Route
            path="/resident/condominiums/:condominiumCd/reserve-facility-top"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityTopPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    condominiumsRepo={condominiumsRepo}
                    facilitiesRepo={facilitiesRepo}
                    reservationsRepo={reservationsRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約TOP | 素敵ネット'}
                    holidaysRepo={holidaysRepo}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/my-reservations"
            element={<RouterPropsInjector>{(props) =>
                <ResidentMyReservationsPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    reservationsRepo={reservationsRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'あなたの予約一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/reservation-status"
            element={<RouterPropsInjector>{(props) =>
                <ResidentFacilityReservationStatusPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    facilitiesRepo={facilitiesRepo}
                    reservationsRepo={reservationsRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'利用日から探す | 素敵ネット'}
                    holidaysRepo={holidaysRepo}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reserve/input"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityInputPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    facilitiesRepo={facilitiesRepo}
                    reservationsRepo={reservationsRepo}
                    holidaysRepo={holidaysRepo}
                    roomNumberRepo={roomNumberRepo}
                    ridgeRepo={ridgeRepo}
                    reservationModel={reservationModel}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reserve/confirm"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityInputConfirmPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    reservationsRepo={reservationsRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約入力確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reserve/complete"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityInputCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reservations/:reserveId/detail"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityDetailPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    reserveId={Number(props.params.reserveId)}
                    facilitiesRepo={facilitiesRepo}
                    reservationsRepo={reservationsRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/extra-reservations/:reserveId/detail"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveExtraReservationPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    reserveId={Number(props.params.reserveId)}
                    facilitiesRepo={facilitiesRepo}
                    reservationsRepo={reservationsRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reservations/:reserveId/confirmationComplete"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityInputCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reservations/:reserveId/update"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityUpdatePage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    reserveId={Number(props.params.reserveId)}
                    facilitiesRepo={facilitiesRepo}
                    reservationsRepo={reservationsRepo}
                    holidaysRepo={holidaysRepo}
                    roomNumberRepo={roomNumberRepo}
                    ridgeRepo={ridgeRepo}
                    reservationModel={reservationModel}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約変更 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route

            path="/resident/condominiums/:condominiumCd/facilities/:id/reservations/:reserveId/updateConfirm"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityUpdateConfirmPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    reserveId={Number(props.params.reserveId)}
                    reservationsRepo={reservationsRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約変更確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reservations/:reserveId/updateComplete"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityUpdateCompletePage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    reserveId={Number(props.params.reserveId)}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約変更完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reservations/:reserveId/cancelConfirm"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityCancelConfirmPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    reserveId={Number(props.params.reserveId)}
                    reservationsRepo={reservationsRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約キャンセル確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/facilities/:id/reservations/:reserveId/cancelComplete"
            element={<RouterPropsInjector>{(props) =>
                <ResidentReserveFacilityCancelCompletePage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    facilityId={Number(props.params.id)}
                    reserveId={Number(props.params.reserveId)}
                    eventEmitter={eventEmitter}
                    pageTitle={'施設予約キャンセル完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path={`/resident/condominiums/:condominiumCd/applications/account-transfer/${RECEIVING_AGENCY_CD.RESONA_KS.value}`}
            element={<RouterPropsInjector>{(props) =>
                <ResidentAccountTransferApplyToResonaPage
                    navigate={props.navigate}
                    tokenRepo={tokenRepo}
                    residentUserRepo={residentUserRepo}
                    condominiumCd={props.params.condominiumCd!}
                    eventEmitter={eventEmitter}
                    pageTitle={'口座振替登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path={`/resident/condominiums/:condominiumCd/applications/account-transfer/${RECEIVING_AGENCY_CD.SMBC_CARD.value}`}
            element={<RouterPropsInjector>{(props) =>
                <ResidentAccountTransferApplyToSmbcPage
                    navigate={props.navigate}
                    residentUserRepo={residentUserRepo}
                    condominiumCd={props.params.condominiumCd!}
                    eventEmitter={eventEmitter}
                    pageTitle={'口座振替登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path={`/resident/condominiums/:condominiumCd/applications/account-transfer/${RECEIVING_AGENCY_CD.SMBC_CARD.value}/privacy-policy`}
            element={<RouterPropsInjector>{(props) =>
                <ResidentAccountTransferPrivacyPolicyToSmbcPage
                    navigate={props.navigate}
                    tokenRepo={tokenRepo}
                    condominiumCd={props.params.condominiumCd!}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人情報保護方針 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/assoc-top"
            element={<RouterPropsInjector>{(props) =>
                <ResidentAssocTopPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    meetingRepoForResident={meetingRepoForResident}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'理事会TOP | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/meetings"
            element={<RouterPropsInjector>{(props) =>
                <ResidentMeetingListPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    meetingRepoForResident={meetingRepoForResident}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'会議一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/meetings/:meetingId"
            element={<RouterPropsInjector>{(props) =>
                <ResidentMeetingDetailPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    meetingId={Number(props.params.meetingId!)}
                    meetingRepoForResident={meetingRepoForResident}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'会議詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/meetings/:meetingId/comments/:commentId/reply"
            element={<RouterPropsInjector>{(props) =>
                <ResidentCommentReplyPage
                    navigate={props.navigate}
                    location={props.location}
                    condominiumCd={props.params.condominiumCd!}
                    meetingId={Number(props.params.meetingId!)}
                    replySourceId={Number(props.params.commentId)}
                    meetingRepoForResident={meetingRepoForResident}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'コメント返信 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/access-control-manager/rikb/redirect"
            element={<RouterPropsInjector>{(props) =>
                <ResidentAccessControlManagerForRikbRedirectPage
                    reservationsRepository={reservationsRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'RIKBリダイレクト | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/public/account-transfer/result/:status"
            element={<RouterPropsInjector>{(props) => {
                // @ts-ignore
                return <AccountTransferApplyResult
                    eventEmitter={eventEmitter}
                    params={props.params}
                    location={props.location}
                    navigate={props.navigate}
                />
            }}</RouterPropsInjector>}
        />
        <Route
            path="/resident/general-meeting/unit-owner-confirmation"
            element={<RouterPropsInjector>{(props) =>
                <ResidentUnitOwnerConfirmationPage
                    location={props.location}
                    navigate={props.navigate}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'区分所有者の確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/general-meeting/unit-owner-confirmation-complete"
            element={<RouterPropsInjector>{(props) =>
                <ResidentUnitOwnerConfirmationCompletePage
                    location={props.location}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'区分所有者確認完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/general-meeting/unit-owner-confirmation-redirect"
            element={<RouterPropsInjector>{(props) =>
                <ResidentUnitOwnerConfirmationRedirectPage
                    location={props.location}
                    navigate={props.navigate}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'区分所有者の確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/general-meeting/unit-owner-confirmation-key-input"
            element={<RouterPropsInjector>{(props) =>
                <ResidentUnitOwnerConfirmationKeyInputPage
                    location={props.location}
                    navigate={props.navigate}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'区分所有者確認用キー入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/general-meeting/unit-owner-confirmation-verification-method-selection"
            element={<RouterPropsInjector>{(props) =>
                <ResidentUnitOwnerConfirmationVerificationMethodSelectionPage
                    location={props.location}
                    navigate={props.navigate}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'確認方法の選択 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings"
            element={<RouterPropsInjector>{(props) =>
                <ResidentGeneralMeetingListPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'総会一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/past"
            element={<RouterPropsInjector>{(props) =>
                <ResidentPastGeneralMeetingListPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'過去の総会一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId"
            element={<RouterPropsInjector>{(props) =>
                <ResidentGeneralMeetingDetailPage
                    location={props.location}
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    ridgeRepo={ridgeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'総会詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId/assocs/:assocId/voting-preference/method-selection"
            element={<RouterPropsInjector>{(props) =>
                <ResidentVotingPreferenceMethodSelectionPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    assocId={Number(props.params.assocId!)}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'総会参加方法の選択 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId/assocs/:assocId/voting-preference/confirmation/attendance"
            element={<RouterPropsInjector>{(props) =>
                <ResidentVotingPreferenceAttendanceConfirmationPage
                    location={props.location}
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    assocId={Number(props.params.assocId!)}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId/assocs/:assocId/voting-preference/input/proxy"
            element={<RouterPropsInjector>{(props) =>
                <ResidentVotingPreferenceProxyInputPage
                    location={props.location}
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    assocId={Number(props.params.assocId!)}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    useFunctionMasterRepo={useFunctionMasterRepo}
                    ridgeRepo={ridgeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'議決権の委任 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId/assocs/:assocId/voting-preference/confirmation/proxy"
            element={<RouterPropsInjector>{(props) =>
                <ResidentVotingPreferenceProxyConfirmationPage
                    location={props.location}
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    assocId={Number(props.params.assocId!)}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId/assocs/:assocId/voting-preference/input/proposal-response"
            element={<RouterPropsInjector>{(props) =>
                <ResidentVotingPreferenceProposalResponseInputPage
                    location={props.location}
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    assocId={Number(props.params.assocId!)}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'議決権の行使 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId/assocs/:assocId/voting-preference/confirmation/proposal-response"
            element={<RouterPropsInjector>{(props) =>
                <ResidentVotingPreferenceProposalResponseConfirmationPage
                    location={props.location}
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    assocId={Number(props.params.assocId!)}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/general-meetings/:generalMeetingId/assocs/:assocId/voting-preference/complete"
            element={<RouterPropsInjector>{(props) =>
                <ResidentVotingPreferenceCompletePage
                    location={props.location}
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    generalMeetingId={Number(props.params.generalMeetingId!)}
                    eventEmitter={eventEmitter}
                    pageTitle={'意思表明完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
    </>)
}
